import React from 'react';

const SessionOfferCard = ({ course, onClick, className }) => {
  const {
    imgUrl,
    title,
    tags,
    totalEnrolls,
    description,
    price,
    time,
    tutorFirstName,
    tutorLastName,
    tutorProgfileImg,
  } = course;
  return (
    <div
      className={`${className} customShadow flex w-[270px] cursor-pointer  flex-col rounded-2xl`}
      onClick={onClick}
    >
      <img src={imgUrl} alt="" className="rounded-xl" />

      <div className="flex flex-col px-3">
        <div className="flex items-center gap-1.5">
          {tags.map((tag, index) => (
            <span
              key={index}
              className="my-[9px] inline-flex w-fit items-center justify-center rounded-2xl bg-gray-200 px-2 text-xs leading-6 text-teal-900"
            >
              {tag}
            </span>
          ))}
        </div>
        <h2 className="fredokaOne mb-1 truncate whitespace-nowrap text-lg leading-6 text-teal-900">
          {title}
        </h2>
        <div className="mb-2 flex items-center gap-2">
          <img src="/images/icons/users-two.svg" alt="" className="size-4" />
          <h3 className=" text-sm leading-6 text-[#014451]">{totalEnrolls} students enrolled</h3>
        </div>
        <p className="text-sm leading-6 text-gray-400 ">{description}</p>
        <div className="mt-4 flex items-center gap-1.5">
          <div className="flex size-6  ">
            <img src={tutorProgfileImg} alt="" className=" " />
          </div>
          <span className=" text-sm leading-6 text-[#014451]">
            {tutorFirstName} {tutorLastName}
          </span>
        </div>
        <div className="my-4  flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <img src="/images/icons/dollar-teal.svg" alt="" className="size-4" />
              <span className="text-sm font-semibold leading-6 text-teal-900">{price}</span>
            </div>
            <div className="flex items-center gap-2">
              <img src="/images/icons/clock-outline-teal.svg" alt="" className="size-4" />
              <span className="text-sm font-semibold leading-6 text-teal-900">{time}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionOfferCard;
